const ArrowIcon = ({className} : {className?:string}) => {
  return (
<svg className={className} width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M18.75 25.3L8.75 15.3L18.75 5.30005L21.25 7.80005L13.75 15.3L21.25 22.8L18.75 25.3Z" fill="currentColor" />
</svg>
  )
}

export default ArrowIcon